;(function($){

    function Select()
    {
        $("select").select2();

        $("select").on("change", function(){
            $("select").select2({
                allowClear: true,
                placeholder: "Selecione"
            });
        });

        $(window).resize(function() {
            $("select").select2({
                allowClear: true,
                placeholder: "Selecione"
            });
        });

        $('select').on('select2:open', function(e) {
            $('.select2-search input').prop('focus',false);
        });

        $('.select2 span').addClass('needsclick');
    }

   	new Select();

}(jQuery));
 
 
 
 
